import { gql } from "@apollo/client";

export const SAVED_FILTERS = gql`
  query SavedFilters($where: ReferentialWhereInput) {
    referentials(where: $where) {
      data {
        id
        name
        type
        entries
      }
      count
    }
  }
`;

export const ADD_SAVED_FILTER = gql`
  mutation AddSavedFilter($data: ReferentialDataInput) {
    addReferential(data: $data) {
      id
      name
      type
      entries
    }
  }
`;

export const DELETE_SAVED_FILTER = gql`
  mutation DeleteSavedFilter($where: ReferentialWhereInput) {
    deleteReferential(where: $where) {
      id
    }
  }
`;
